module.exports = __webpack_public_path__ + "static/assets/4bc53ecad0450ce7911779ef5e9ebd96.png";